import React, { useEffect, useState, useRef } from 'react';
import { SideSheet, PasswordVerificationSideSheet } from '@desquared/wave-components-library';
import { useTranslations } from 'next-intl';
import Router, { useRouter } from 'next/router';
import getLayoutProps from '@/utils/layout/layout';
import { PassVerificationSideSheetStore } from '@/store/sideSheet';
import PasswordSidesheet from '../../../public/assets/wave-grocery/PasswordSidesheet.png';
import { updateUserV3 } from '@/api/users';
import { OTPIDStore } from '@/store/otpid';
import { OTPVerificationSideSheetStore } from '@/store/sideSheet';
import User from '@/store/user';
import { updateUser as updateUserInContactPigeon } from '@/utils/contactPigeon';

export default function PassVerificationSideSheet({ user, userDetails, subTitle }) {
  const t = useTranslations();
  const router = useRouter();

  const [sideSheet, setSideSheet] = useState(false);
  const [password, setPassWord] = useState('');
  const [passwordErrorText, setPasswordErrorText] = useState('');
  const [image, setImage] = useState();

  const refOne = useRef(null);
  const onClick = () => {
    setTimeout(() => {
      PassVerificationSideSheetStore.close();
    }, '300');
  };
  useEffect(() => {
    const PassVerificationSideSheetStore$ = PassVerificationSideSheetStore.subscribe(setSideSheet);

    document.addEventListener('click', handleClickOutside, true);
    async function getProps() {
      const layoutProps = await getLayoutProps({ headerProps: { selectedIndex: -1 } }, Router.locale);
      const imagePass = layoutProps?.emptyStates?.change_password?.url
        ? layoutProps?.emptyStates?.change_password?.url
        : null;
      setImage(imagePass);
    }
    getProps();

    return () => {
      PassVerificationSideSheetStore$.unsubscribe();

      document.removeEventListener('click', handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = e => {
    if (refOne.current && !refOne.current.contains(e.target)) {
      PassVerificationSideSheetStore.close();
    }
  };

  async function updateUserDetails() {
    const updatedFields = { ...userDetails, password: password };
    try {
      const { response } = await updateUserV3(user.authToken, updatedFields, router.locale);
      if (response.data.status === 'SUCCESS') {
        if (response.data.user) {
          User.update({ ...user, ...response.data.user });
          if (process.env.hasContactPigeon) {
            updateUserInContactPigeon(response.data.user.email);
          }
        }
        PassVerificationSideSheetStore.close();
      } else if (response.data.status === 'NEED_VERIFICATION') {
        OTPIDStore.update({ requestId: response.data.otpInfo.requestId, email: userDetails.email });
        PassVerificationSideSheetStore.close();
        OTPVerificationSideSheetStore.open();
      }
    } catch (error) {
      setPasswordErrorText(error?.response?.data?.userMessage);
    }
  }

  const onPassWordChange = e => {
    setPassWord(e.currentTarget.value);
    setPasswordErrorText('');
  };

  if (!sideSheet) return null;
  return (
    <div ref={refOne}>
      <SideSheet hasClose={true} onClose={onClick} position="right">
        <PasswordVerificationSideSheet
          title={t('user_credentials.verification.security_check')}
          subTitle={subTitle}
          image={image ? image : PasswordSidesheet.src}
          displayName="password verification image"
          passwordlLabelText={t('user_credentials.verification.password')}
          passwordHelperTextType={passwordErrorText ? 'error' : 'helper'}
          passwordPlaceHolderText={t('user_credentials.verification.password')}
          onPassWordChange={onPassWordChange}
          passwordValue={password}
          onSubmitForm={updateUserDetails}
          onCancel={onClick}
          submitText={t('user_credentials.verification.continue')}
          cancelText={t('user_credentials.verification.cancel_edit')}
          passwordErrorText={passwordErrorText ?? passwordErrorText}
        />
      </SideSheet>
    </div>
  );
}
